import {
  NzButtonType,
  NzButtonShape,
  NzButtonSize,
} from 'ng-zorro-antd/button';

export class Btn {
  value?: string;
  text?: string;
  type?: NzButtonType;
  url?: string;
  danger?: boolean;
  ghost?: boolean;
  shape?: NzButtonShape;
  size?: NzButtonSize;
  faClassPrefix?: string;
  faClassSuffix?: string;
  nzTypePrefix?: string;
  nzTypeSuffix?: string;
}
